import React, {useState} from 'react'
import {Headers} from '../../types'
import {useQuery} from 'react-query'
import {Get} from '../../../../../../setup'
import {CampaignInterface, ExtendedCampaignInterface,} from '../../../../../../app/pages/mailing/campaigns/types'
import {useMailing} from '../../../../../../app/@types'
import {DataTableWebForm} from '../../components/DataTable.web-form'

const headers: Headers<CampaignInterface>[] = [
  {key: 'created_at', label: 'Date d\'envoi', className: 'fw-bolder text-muted bg-light min-w-150px'},
  {key: 'name', label: 'Titre', className: 'fw-bolder text-muted bg-light min-w-200px'},
  {key: 'subject', label: 'Sujet', className: 'fw-bolder text-muted bg-light min-w-250px'},
  {key: 'from_email', label: 'E-mails', className: 'fw-bolder text-muted bg-light min-w-150px'},
  {key: 'open_count', label: 'Ouvertures', className: 'fw-bolder text-muted bg-light min-w-100px'},
  {key: 'click_count', label: 'Clics', className: 'fw-bolder text-muted bg-light min-w-100px'},
  {key: '_status', label: 'statut', className: 'fw-bolder text-muted bg-light min-w-100px'},
]

const TypesChampagne = [
  {id: 1, name: 'Brouillons', color: 'secondary'},
  {id: 2, name: 'Programmées', color: 'primary'},
  {id: 3, name: 'En cour d\'envoi', color: 'warning'},
  {id: 4, name: 'Envoyées', color: 'success'},
  {id: 5, name: 'Archivées', color: 'info'},
  {id: 6, name: 'Favoris', color: 'warning'},
]

const addStatusName = (data: ExtendedCampaignInterface[], types: typeof TypesChampagne) => {
  return data.map(item => {
    const foundType = types.find(type => type.id === item.status_id)
    return {
      ...item,
      _status: foundType ? foundType.name : 'Unknown',
    }
  })
}

const ALL = process.env.REACT_APP_MAILING_ALL_CAMPAIGN || 'v2/campaigns'
const TablesWidget16 = () => {

  const {reloadKey} = useMailing()
  const [data, setData] = useState<ExtendedCampaignInterface[]>([])

  useQuery(
    [`MAILING_CAMPAIGN_ALL`, reloadKey],
    () => Get<{data: ExtendedCampaignInterface[]}>({endpoint: ALL}),
    {
      onSuccess: ({data}) => {
        const updatedData = addStatusName(data, TypesChampagne)
        setData(updatedData)
      },
    },
  )

  return <DataTableWebForm headers={headers} data={data} favorite={true} />
}

export {TablesWidget16}